<script lang="ts">
	//Design system components
	import { Text, Container, Radio } from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { createEventDispatcher, getContext, onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';

	const scheduleStore: SvelteStore<any> = getContext('schedule');
	export let text = $format('select_type', {
		values: { type: $format('process_action') },
	});
	//This component is used for all wrappers and also is used as main wrapper where we just need on off option as Action for schedules
	export let selection =
		typeof $scheduleStore.brightness !== 'string'
			? $scheduleStore._options[$scheduleStore.options.indexOf($scheduleStore.selection)] ||
				$scheduleStore._options[0]
			: $scheduleStore._options[2]; //_options[2] is brightness or position

	const dispatch = createEventDispatcher();
	const changeAction = (value) => {
		dispatch('update', {
			selection: $scheduleStore.options[$scheduleStore._options.indexOf(value)],
		});
	};

	onMount(() => {
		dispatch('update', {
			selection: $scheduleStore.options[$scheduleStore._options.indexOf(selection)],
		});
	});
</script>

<Container padding="scrollPaddings">
	<svelte:fragment>
		<Text class="mb-s" element="h2">
			{text}
		</Text>

		{#each $scheduleStore._options as option}
			<Radio
				bind:selected={selection}
				value={option}
				size="m"
				on:click={(e) => {
					changeAction(e.target.value);
				}}
				id="radio-g9ojeze"
			>
				{$format(`schedule_action_${option}`)}
			</Radio>
		{/each}
	</svelte:fragment>
</Container>
